<div class="company-pins">
  <div class="filter-card">
    <div class="filter-group">
      <label>Address</label>
      <nz-input-group nzPrefixIcon="search">
        <input nz-input [(ngModel)]="addressSearch" (ngModelChange)="applyFilters()"
          placeholder="Street, city, zip..." />
      </nz-input-group>
    </div>
    <div class="filter-group">
      <label>Assigned to</label>
      <nz-select [(ngModel)]="selectedRep" (ngModelChange)="applyFilters()" nzAllowClear nzPlaceHolder="All reps"
        style="width: 100%; min-width: 160px;">
        <nz-option *ngFor="let r of repOptions" [nzLabel]="r" [nzValue]="r"></nz-option>
      </nz-select>
    </div>
    <div class="filter-group">
      <label>Disposition</label>
      <nz-input-group nzPrefixIcon="search">
        <input nz-input [(ngModel)]="dispositionSearch" (ngModelChange)="applyFilters()"
          placeholder="EX: Not Home" />
      </nz-input-group>
    </div>
    <div class="filter-group">
      <label>Last Modified Date</label>
      <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)" nzAllowClear
        nzFormat="MM/dd/yyyy" [nzPlaceHolder]="['Start date', 'End date']" style="width: 100%; min-width: 220px;">
      </nz-range-picker>
    </div>
    <div class="filter-actions">
      <button nz-button nzType="default" (click)="clearFilters()">
        Clear filters
      </button>
      <span class="pill">Showing {{ filteredPinList.length }} pins</span>
    </div>
  </div>
  <div style="padding: 0 20px 20px 20px;">
    <nz-tabset nzType="card" (nzSelectedIndexChange)="onTabChange($event)">
      <nz-tab nzTitle="Active Leads"></nz-tab>
      <nz-tab nzTitle="Inactive Leads"></nz-tab>
    </nz-tabset>
  </div>
  <nz-table #pinTable [nzLoading]="loading" [nzData]="filteredPinList" [nzPageIndex]="1" nzShowSizeChanger [nzPageSize]="10" [nzFrontPagination]="true">
    <thead>
      <tr>
        <th>Address</th>
        <th>Last Modified Date</th>
        <th>Assigned To</th>
        <th>Current Disposition</th>
        <th>History</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of pinTable.data">
        <td>{{ p.address_line_1 }}, {{ p.address_zip }}</td>
        <td>{{ p.date | date:'mediumDate' }}</td>
        <td *ngIf="p.first_name">{{ p.first_name | titlecase }} {{ p.last_name | titlecase }}</td>
        <td *ngIf="!p.first_name">Unassigned</td>
        <td>{{ p.disposition }}</td>
        <td>
          <button nz-button nzType="default" (click)="getHistory(p.pin_id)">See History</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<nz-modal [nzVisible]="showModal" [nzTitle]="'Pin History'" [nzWidth]="480" (nzOnCancel)="showModal = false"
  [nzContent]="modalContent">
  <ng-template #modalContent>
    <div *ngFor="let h of history">
      <p>{{ h.text }} - {{ h.date | date:'MMM d, y, h:mm:ss a':'America/Denver' }} (MST)</p>
    </div>
  </ng-template>
  <ng-template #editModalFooter>
    <button nz-button nzType="default" (click)="showModal = false">Cancel</button>
  </ng-template>
</nz-modal>